import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "hamburger"]

  toggle() {
    this.menuTarget.classList.toggle("active")
    this.hamburgerTarget.classList.toggle("active")
    
    // Prevent body scroll when menu is open
    if (this.menuTarget.classList.contains("active")) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }

  close() {
    this.menuTarget.classList.remove("active")
    this.hamburgerTarget.classList.remove("active")
    document.body.style.overflow = ""
  }
}

